import React, { useCallback, useEffect, useState } from "react";
import { PageTitle } from "../PageTitle";
import { APIConfigurationService } from "../../services";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import { faLock, faUnlock } from "@fortawesome/fontawesome-free-solid/";
import moment from "moment-timezone";
import { Col, Row } from "react-bootstrap";

const APIKeyDetail = ({ apiKey, onDelete }) => {
    const [hideValue, setHideValue] = useState(true);

    return (
        <div className="card-data-cell remove-border-left" style={{ paddingTop: 20, paddingBottom: 5 }}>
            <Row>
                <hr />
            </Row>

            <Row>
                <Col md={2}>
                    <div style={{ paddingTop: 15 }} className="pull-right">
                        Value:
                    </div>
                </Col>
                <Col md={8}>
                    <pre>
                        {hideValue && <span>************************************</span>}
                        {!hideValue && <span>{apiKey.key}</span>}
                    </pre>
                </Col>
                <Col md={1}>
                    <div style={{ paddingTop: 15 }} className="pull-left">
                        <FontAwesomeIcon icon={hideValue ? faUnlock : faLock} onClick={() => setHideValue(!hideValue)} />
                    </div>
                </Col>
            </Row>

            <Row>
                <Col md={2}>
                    <span className="pull-right">Created:</span>
                </Col>
                <Col md={8}>
                    <b>{moment(apiKey.createdAt).format("L LT")}</b>
                </Col>
            </Row>

            <Row style={{ paddingTop: 5 }}>
                <Col md={2}>
                    <span className="pull-right">Grants:</span>
                </Col>
                <Col md={8}>
                    <b>{apiKey.grants.map((grant) => grant === "ALL_READ_ONLY" ? "Read Only" : "Read Write").join(", ")}</b>
                </Col>
            </Row>

            <Row>
                <button className="btn btn-danger btn-sm pull-right" type="button" style={{ marginRight: 20 }} onClick={() => onDelete(apiKey.id)}>
                    Delete
                </button>
            </Row>
        </div>
    );
};

const APIKeys = () => {
    const [loading, setLoading] = useState(true);
    const [apiKeys, setApiKeys] = useState([]);

    useEffect(() => {
        setLoading(true);
        APIConfigurationService.getAPIKeys()
            .then(({apiKeys}) => {
                setApiKeys(apiKeys);
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => setLoading(false));
    }, []); 

    const createNew = useCallback((grants) => {
        setLoading(true);
        APIConfigurationService.createAPIKey(grants)
            .then(({ apiKey }) => {
                let keys = [...apiKeys];
                keys.push(apiKey);
                setApiKeys(keys);
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => setLoading(false));
    }, [apiKeys]);

    const deleteKey = useCallback((id) => {
        setLoading(true);
        APIConfigurationService.deleteAPIKey(id)
            .then(() => {
                setApiKeys(apiKeys.filter((apiKey) => apiKey.id != id));
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => setLoading(false));
    }, [apiKeys]);

    return (
        <div>
            <div className="row">
                <PageTitle title="API Keys" />
            </div>

            <div className="op-content-box">
                { loading && <div className="loader">Loading...</div> }
                { !loading && 
                    <div>
                        <div className="row pull-right" style={{paddingRight: 20}}>
                            <button className="btn btn-primary btn-sm" type="button" onClick={() => createNew(['ALL_READ_ONLY'])}>Create New - Read Only</button>
                            &nbsp;&nbsp;
                            <button className="btn btn-primary btn-sm" type="button" onClick={() => createNew(['ALL_READ_WRITE'])}>Create New - Read Write</button>
                        </div>

                        <div style={{padding: 10}}>
                            { apiKeys.length == 0 && <div>No keys</div>}
                            { apiKeys.map((apiKey) => <APIKeyDetail key={apiKey.id} apiKey={apiKey} onDelete={deleteKey} />) }                        
                        </div>
                    </div>
                }
            </div>        
        </div>
    );
};

export default APIKeys;